import offerTpl from './offer.tpl.html!text';

export function offerComponent() {
    return {
        restrict: 'E',
        scope: {},
        replace: true,
        transclude: true,
        template: offerTpl,
        controllerAs: 'vm',
        controller: OfferCtrl,
        bindToController: {
            offers: '='
        }
    };
}

export class OfferCtrl {

    constructor($window) {
        this.$window = $window;
        this.offer = this.offers[0];
        this.backgroundColor = this.offer.backgroundColor;
        this.bannerLink = this.offer.bannerLink;
        this.link = this.offer.link;
        this.termsAndConditionsLink = this.offer.termsAndConditionsLink;
    }

    go() {
        if (this.link) {
            this.$window.open(this.link, '_blank');
        }
    }
}

OfferCtrl.$inject = ['$window'];

export default angular.module('offer', [])
    .directive('offer', offerComponent)
    .name;